import React from "react";
import { array, object } from "prop-types";
import { connect } from "react-redux";
import get from "lodash/get";

import Headline from "../../atoms/Headline";
import RelatedStory from "../../atoms/RelatedStory";
import { staticTexts } from "../../utils/Translate";

import "./relatedStoriesWithImageRight.m.css";

const RelatedStoriesWithImageRight = ({ stories, publisherAttributes }) => (
  <div styleName="related-stories">
    <Headline
      text={staticTexts(publisherAttributes.lang).readMore}
      headerLevel={3}
      headlineType={6}
      className="heading"
    />
    <div styleName="related-stories-section">
      {stories.map(({ story }) => (
        <RelatedStory story={story} key={story.id} />
      ))}
    </div>
  </div>
);

RelatedStoriesWithImageRight.propTypes = {
  stories: array.isRequired,
  publisherAttributes: object,
};

const mapStateToProps = (state) => ({
  publisherAttributes: get(state, ["qt", "config", "publisher-attributes"], {}),
});

export default connect(mapStateToProps, null)(RelatedStoriesWithImageRight);
